/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CandidateReviewSummaryReason = typeof CandidateReviewSummaryReason[keyof typeof CandidateReviewSummaryReason] | null;


export const CandidateReviewSummaryReason = {
  already_contacted: 'already_contacted',
  failed_assessment: 'failed_assessment',
  not_a_fit: 'not_a_fit',
  other: 'other',
} as const;
